(() => {
  const SECTION_SEL = '[data-bewo-sticker-explosion]';

  const parseConfig = (root) => {
    const configId = root.getAttribute('data-config-id');
    const el = configId ? document.getElementById(configId) : null;
    const raw = el ? el.textContent : root.getAttribute('data-config');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  };

  const clearNode = (node) => {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  };

  const imageUrl = (src) => {
    if (!src) return '';
    if (src.startsWith('//')) return `https:${src}`;
    return src;
  };

  const closeExplosion = (root, button, fadeMs) => {
    const overlay = root._bewoSeOverlay;
    if (!overlay) {
      root._bewoSeBusy = false;
      return;
    }

    const picture = overlay.querySelector('.bewo-sticker-explosion__full');
    const duration = Math.max(180, fadeMs || 400);

    if (picture) {
      picture.getAnimations().forEach((animation) => animation.cancel());
      picture.animate(
        [
          { opacity: 1, transform: 'scale(1)' },
          { opacity: 0, transform: 'scale(1.04)' },
        ],
        {
          duration,
          easing: 'ease-in',
          fill: 'forwards',
        }
      );
    }

    window.setTimeout(() => {
      clearNode(overlay);
      root._bewoSeOverlay = null;
      root._bewoSeBusy = false;
      button.classList.remove('is-open');
    }, duration);
  };

  const explode = (root, button, config) => {
    if (root._bewoSeBusy) {
      closeExplosion(root, button, config.fadeMs);
      return;
    }

    const src = imageUrl(config.fullImage);
    if (!src) return;

    root._bewoSeBusy = true;
    button.classList.add('is-open');
    clearNode(root._bewoSeOverlay);

    const overlay = document.createElement('div');
    overlay.className = 'sticker-explosion-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    const picture = document.createElement('img');
    picture.className = 'bewo-sticker-explosion__full';
    picture.src = src;
    picture.alt = '';
    picture.decoding = 'async';

    overlay.appendChild(picture);
    document.body.appendChild(overlay);
    root._bewoSeOverlay = overlay;

    picture.animate(
      [
        { opacity: 0, transform: 'scale(1.06)' },
        { opacity: 1, transform: 'scale(1)' },
      ],
      {
        duration: Math.max(220, config.fadeMs || 400),
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'forwards',
      }
    );

    overlay.addEventListener('click', () => {
      closeExplosion(root, button, config.fadeMs);
    });
  };

  const init = (root) => {
    if (root._bewoSeInit) return;
    root._bewoSeInit = true;

    if (window.Shopify && Shopify.designMode) return;

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    const config = parseConfig(root);
    const button = root.querySelector('[data-bewo-sticker-explosion-btn]');
    if (!config || !button) return;

    button.addEventListener('click', () => {
      explode(root, button, config);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root._bewoSeOverlay) {
        closeExplosion(root, button, config.fadeMs);
      }
    });
  };

  const boot = () => {
    document.querySelectorAll(SECTION_SEL).forEach(init);
  };

  document.addEventListener('shopify:section:load', (event) => {
    const next = event.target.querySelector?.(SECTION_SEL) || event.target.closest?.(SECTION_SEL);
    if (next) init(next);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
